import {
    createLocalUrlFromS3,
    IS3ExternalData
} from "customHooks/useCompleoForm/Inputs/File/File";
import { getExtension } from "functions/util";
import React from "react";
import ModalViewFile, { AllowedExtensionsViewFile } from "./ModalViewFile";

interface IFileData {
    extension: AllowedExtensionsViewFile;
    path: string;
    isLocalStreamUrl?: boolean;
    t: any;
    externalData?: IS3ExternalData;
    fileName?: string;
}
const useModalViewFile = (t: any) => {
    const [open, setOpen] = React.useState(false);
    const [fileData, setFileData] = React.useState<IFileData>({
        extension: "blank",
        path: "",
        t: t
    });
    const ModalComponentViewFile = (
        <ModalViewFile
            extension={fileData.extension}
            open={open}
            handleClose={() => setOpen(false)}
            path={fileData.path}
            t={t}
            isLocalStreamUrl={fileData.isLocalStreamUrl}
            fileName={fileData.fileName}
        />
    );

    const viewFile = (
        path: string,
        extension: AllowedExtensionsViewFile,
        isLocalStreamUrl?: boolean,
        fileName?: string
    ) => {
        setFileData({
            extension: extension,
            path: path,
            t: t,
            isLocalStreamUrl: isLocalStreamUrl,
            fileName
        });
        setOpen(true);
    };

    const viewFileS3Key = async (
        key: string,
        externalData?: IS3ExternalData,
        fileName?: string
    ) => {
        const extension: AllowedExtensionsViewFile = getExtension(
            key
        ) as AllowedExtensionsViewFile;
        const url = await createLocalUrlFromS3(key, false, externalData);
        setFileData({
            extension: extension,
            path: url.url,
            t: t,
            isLocalStreamUrl: true,
            fileName
        });
        setOpen(true);
    };

    return {
        ModalComponentViewFile,
        viewFile: viewFile,
        viewFileS3Key: viewFileS3Key,
        open: open
    };
};

export default useModalViewFile;
